(() => {
  const DEBUG_UPSELL = true;
  const dbg = (...a) => DEBUG_UPSELL && console.debug("[CartUpsell]", ...a);
  const oops = (...a) => DEBUG_UPSELL && console.warn("[CartUpsell]", ...a);

  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  // ✅ Use Theme.routes where available
  const ADD_URL = window.Theme?.routes?.cart_add_url || "/cart/add.js"; // CHANGED
  const CART_JS_URL = window.Theme?.routes?.cart_url
    ? `${Theme.routes.cart_url}.js`
    : "/cart.js";
  const SECTIONS_URL = window.Theme?.routes?.cart_url || "/cart"; // CHANGED
  const TXT_ADDED = window.Theme?.translations?.added || "Added!"; // CHANGED

  // Use capture to beat any stopPropagation in other handlers
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-upsell-id]");
      if (!btn) return;
      e.preventDefault();
      dbg("Click add", { variantId: btn.dataset.upsellId });
      addItem(btn.dataset.upsellId, 1, btn);
    },
    { capture: true }
  );

  // Register once (don’t add this inside addItem)
  document.documentElement.addEventListener("cart:refresh", () => {
    syncHeaderBubbleFromCart();
  });

  async function addItem(id, quantity, btn) {
    const prevText = btn.textContent;
    try {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.textContent = "Adding…";

      dbg("POST", { url: ADD_URL, id, quantity });
      const res = await fetch(ADD_URL, {
        // CHANGED
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, quantity }),
      });

      const data = await res.json().catch(() => ({}));
      dbg("Add response", { ok: res.ok, status: res.status, data });
      if (!res.ok) throw new Error(data?.description || "Add to cart failed");

      const refreshed = await refreshCartUI({ openIfMissing: true });
      dbg("refreshCartUI done", { refreshed });
      await syncHeaderBubbleFromCart();

      btn.textContent = TXT_ADDED; // CHANGED
      setTimeout(() => (btn.textContent = prevText), 900);
    } catch (err) {
      oops("Add failed", err);
      const msg = btn.nextElementSibling?.classList?.contains(
        "cart-upsell__error"
      )
        ? btn.nextElementSibling
        : document.createElement("p");
      msg.className = "cart-upsell__error";
      msg.textContent = err.message || "Could not add this item";
      btn.insertAdjacentElement("afterend", msg);
    } finally {
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    }
  }

  function updateHeaderCartBubbles(count) {
    const icons = document.querySelectorAll(
      'cart-icon[data-testid="cart-icon"]'
    );
    icons.forEach((icon) => {
      const countEl = icon.querySelector(".cart-bubble__text-count");
      const srEl = icon.querySelector(".cart-bubble__text .visually-hidden");
      const bubble = icon.querySelector(".cart-bubble");
      if (countEl) countEl.textContent = String(count);
      if (srEl) srEl.textContent = `Total items in cart: ${count}`;
      if (bubble) bubble.hidden = count <= 0;
      icon.classList.toggle("header-actions__cart-icon--has-cart", count > 0);
    });
    dbg("Header bubbles updated", { count, iconCount: icons.length });
  }

  async function syncHeaderBubbleFromCart() {
    try {
      const cart = await fetch(CART_JS_URL, {
        // CHANGED
        headers: { Accept: "application/json" },
        cache: "no-store",
        credentials: "same-origin",
      }).then((r) => r.json());
      updateHeaderCartBubbles(cart.item_count ?? 0);
    } catch (e) {
      dbg("syncHeaderBubbleFromCart failed", e);
    }
  }

  async function refreshCartUI({ openIfMissing = false } = {}) {
    let mount = document.querySelector(
      "cart-drawer-component .cart-items-component[data-section-id]"
    );
    dbg("refreshCartUI:start", { openIfMissing, mountFound: !!mount });

    if (!mount && openIfMissing) {
      document.querySelector("cart-drawer-component")?.open?.();
      await new Promise((r) => requestAnimationFrame(() => setTimeout(r, 60)));
      mount = document.querySelector(
        "cart-drawer-component .cart-items-component[data-section-id]"
      );
      dbg("drawer opened, mount found?", !!mount);
    }

    if (mount) {
      const sectionId = mount.dataset.sectionId;
      const url = `/?sections=${encodeURIComponent(
        sectionId
      )}&sections_url=${encodeURIComponent(SECTIONS_URL)}`; // CHANGED
      dbg("Section render attempt", { sectionId, url });

      try {
        const res = await fetch(url, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
          cache: "no-store",
        });
        dbg("Section render response", { ok: res.ok, status: res.status });

        const htmlById = await res
          .json()
          .catch((e) => (oops("JSON parse failed", e), null));
        const html = htmlById?.[sectionId];
        dbg("Section html present?", !!html);

        if (html) {
          const doc = new DOMParser().parseFromString(html, "text/html");

          const nextItems = doc.querySelector(".cart-drawer__items");
          const nextSummary = doc.querySelector(".cart-drawer__summary");
          const curItems = document.querySelector(
            "cart-drawer-component .cart-drawer__items"
          );
          const curSummary = document.querySelector(
            "cart-drawer-component .cart-drawer__summary"
          );
          if (nextItems && curItems) curItems.outerHTML = nextItems.outerHTML;
          if (nextSummary && curSummary)
            curSummary.outerHTML = nextSummary.outerHTML;

          const nextHeaderBubble = doc.querySelector(".cart-bubble");
          const curHeaderBubble =
            document.querySelector("#cart-drawer-header .cart-bubble") ||
            document.querySelector("cart-drawer-component .cart-bubble");
          if (nextHeaderBubble && curHeaderBubble)
            curHeaderBubble.outerHTML = nextHeaderBubble.outerHTML;

          const nextHeaderBtn = doc.querySelector("button[aria-label]");
          const curHeaderBtn = document.querySelector(
            "cart-drawer-component button[aria-label]"
          );
          if (nextHeaderBtn && curHeaderBtn)
            curHeaderBtn.setAttribute(
              "aria-label",
              nextHeaderBtn.getAttribute("aria-label")
            );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh")
          );
          return true;
        }
      } catch (e) {
        oops("Section render fetch failed", e);
      }
    }

    try {
      const cart = await fetch(CART_JS_URL, {
        headers: { Accept: "application/json" },
      }) // CHANGED
        .then((r) => r.json());
      dbg("Fallback /cart.js", {
        item_count: cart.item_count,
        total_price: cart.total_price,
      });
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
      return true;
    } catch (e) {
      oops("Fallback /cart.js failed", e);
      return false;
    }
  }
})();
